import ApiToken from './container';

export default ApiToken;



// WEBPACK FOOTER //
// ./src/views/Setup/ApiToken/index.js